import { Activity, ActivityService } from '../../activity';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService, LazyLoadEvent } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { ActivityProviderService } from '@app/_components/activity-provider/activity-provider.service';
import { PersonService } from '@app/_components/person';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, first } from 'rxjs';
import { PictureService } from '@app/_components/picture/picture.service';
import { Image } from '../../property/image/property-image';
import { SpringQuery } from '@app/_helpers/spring-query';

@Component({
    selector: 'app-activity',
    templateUrl: './activity.component.html',
    styleUrls: ['./activity.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ActivityComponent implements OnInit {
    activityProviderId: any;
	activityTypes: any;
	countries: any[];
    addressTypes: any;
	states: any[];
    locationCategories: any;
	newLine = '\r\n';
    textHighlight: string;
	activityProviderIdRequired = false;

	// data
	uploadedFiles: any[] = [];
	pictureArray: any[] = [];
	pictures: any[] = [];
	pictureSorting: any[] = [];
	image: Image;
	images: any[] = [];
	forDeletePictures: any[] = [];


	// datalist
	lazyLoadEvent: LazyLoadEvent;
	recordTotal: number;
	loading = true;
	multiSortMeta = [];
	first = 0;
	rows = 50;

	pictureProperties: any = {};
	pictureData: any;
    pictureIndex: number;
	isPicture = false;
	availabilityList: any[] = [];
	pickUpList: any[] = [];
	accessibleList: any[] = [];
	eatingList: any[] = [];
	languageList: any[] = [];
	overviewsArray: any[] = [];
	
	constructor(
		private constantService: ConstantService,
		private personService: PersonService,
		private activityProviderService: ActivityProviderService,
		private primengConfig: PrimeNGConfig,
		private activityService: ActivityService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private pictureService: PictureService,
		private formBuilder: UntypedFormBuilder,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		@Inject(MAT_DIALOG_DATA) data: any) {
		//this.formTitle = data.title,
			/*this.activity = data.activity,
			this.activityProviderId = data.activityProviderId,*/
			this.availabilityList = activityService.availabilityList;
			this.pickUpList = activityService.pickUpList;
			this.accessibleList = activityService.accessibleList;
			this.eatingList = activityService.eatingList;
			this.languageList = activityService.languageList;

			this.statuses = activityService.statuses;
			this.locationCategories = [
				{ value: 'land', name: 'Land' },
				{ value: 'air', name: 'Air' },
				{ value: 'ocean', name: 'Ocean' },
				{ value: 'mountain', name: 'Mountain' },
				{ value: 'lake', name: 'Lake' },
			];
			this.activityTypes = activityService.activityTypes;
			this.addressTypes =  this.personService.addressTypes;
			this.countries =  this.personService.countries;
			this.states =  this.constantService.states;
			if(this.router.getCurrentNavigation()?.extras?.state?.activityProviderId != undefined){
				this.activityProviderId = this.router.getCurrentNavigation()?.extras?.state?.activityProviderId;
			}
			if(this.router.getCurrentNavigation()?.extras?.state?.activity != undefined){
				this.activity = this.router.getCurrentNavigation()?.extras?.state?.activity;
			}
			this.formTitle = this.router.getCurrentNavigation()?.extras?.state?.title;
	}

	@Input() activity: Activity;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	activityId: number;
	activityProviders: any;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;
	formAction: String;
	formLabels = [];
	formReadOnly = false;
	subscription: Subscription;

	statuses: any;

	columns: any[] = [
		{ field: 'pictureId', header: 'pictureId', width: 'auto' },
	];

	validationMessages = {
		'activityId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'opsNotes': [
			{ type: 'required', message: 'Required' }
		],
		'status': [],
		'activityType': [],
		'invoiceType': [],
		'overviewDesc': [],
		'detailsDesc': [],
		'duration': [],
		'durationDesc': [],
		'checkInDesc': [],
		'parkingDesc': [],
		'menuDesc': [],
		'cancelPolicy': [],
		'activityProviderId': [],
		'adrType': [],
		'adrStreetNumber': [],
		'adrStreetName': [],
		'adrUnit': [],
		'adr2': [],
		'adrCity': [],
		'adrCounty': [],
		'adrCountry': [],
		'adrRegion': [],
		'adrState': [],
		'adrPostalCode': [],
		'adrIsland': [],
		'adrCrossStreet': [],
		'adrLongitude': [],
		'adrLatitude': [],
		'locationCategory': [],
		'highlightDesc': [],
		'feeDesc': [],
		'scheduleDesc': [],
		'termsDesc': [],
		availableDays: [],
		pickUpAvailable: [],
		accessibleTransport: [],
		eatingTime: [],
		language: [],
		leadDescription: [{ type: 'required', message: 'Required' }],
	};

	ngOnInit() {
		// formAction
		this.formAction = this.router.url.startsWith('/activity-add') ? 'add' : this.router.url.startsWith('/activity-edit') ? 'edit' : '/';
		try {
			// add
			if (this.formAction === 'add') {
				this.formLabels['title'] = 'Add New Activity';
				this.formReadOnly = false;
				this.formBuild();
			}

			// edit
			else if (this.formAction === 'edit') {

				this.subscription = this.activatedRoute.params.subscribe(params => {
					this.activityId = params.activityId; // (+) converts string 'id' to a number
				});
				try {
					this.activityService.findById(this.activityId)
						.subscribe(
							res => {
								// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
								this.activity = res.data.activity;
								if(this.activity.availableDays != undefined && this.activity.availableDays != null){
									this.overviewsArray = [];
									this.activity.availableDays.split(", ").forEach(availableDay => {
										const availableDayData = { value: availableDay, name: availableDay };
										this.overviewsArray.push(availableDayData);
									});
									this.activity.availableDays = this.overviewsArray;
								}
								if(this.activity.pickUpAvailable != undefined && this.activity.pickUpAvailable != null){
									this.overviewsArray = [];
									this.activity.pickUpAvailable.split(", ").forEach(pickUpAvail => {
										const pickUpAvailData = { value: pickUpAvail, name: pickUpAvail };
										this.overviewsArray.push(pickUpAvailData);
									});
									this.activity.pickUpAvailable = this.overviewsArray;
								}
								if(this.activity.accessibleTransport != undefined && this.activity.accessibleTransport != null){
									this.overviewsArray = [];
									this.activity.accessibleTransport.split(", ").forEach(accessibleTran => {
										const accessibleTranData = { value: accessibleTran, name: accessibleTran };
										this.overviewsArray.push(accessibleTranData);
									});
									this.activity.accessibleTransport = this.overviewsArray;
								}
								if(this.activity.eatingTime != undefined && this.activity.eatingTime != null){
									this.overviewsArray = [];
									this.activity.eatingTime.split(", ").forEach(eatTime => {
										const eatTimeData = { value: eatTime, name: eatTime };
										this.overviewsArray.push(eatTimeData);
									});
									this.activity.eatingTime = this.overviewsArray;
								}
								if(this.activity.language != undefined && this.activity.language != null){
									this.overviewsArray = [];
									this.activity.language.split(", ").forEach(lang => {
										const langData = { value: lang, name: lang };
										this.overviewsArray.push(langData);
									});
									this.activity.language = this.overviewsArray;
								}
								
								this.activityId = this.activity.activityId;
								this.fixDates();
								this.form1.patchValue(this.activity);
								return this.activity;
							},
							err => {
								console.log('Activity-Update FAIL: ' + JSON.stringify(err));
								this.alertService.error(err);
							},
							() => { });
					} catch (error) {
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.alertService.error(error);
				}
				
				this.formLabels['title'] = 'Edit';
				this.formReadOnly = false;
				this.formBuild();
				
				// patch in data
				//this.form1.patchValue(this.activity);
			}
		}
		catch (error) {
			console.log('Error: ' + error);
		}
		this.textHighlight = 'Close To Water' + this.newLine + 'Easy to access' + this.newLine + 'Fun to do' + this.newLine + '5 min to the sea' + this.newLine + 'Beautiful ocean views';
		this.fetchActivityProviders();
		console.log("data.activityProviderId : "+this.activityProviderId);
			console.log("data.title : "+this.formTitle);
			console.log("data.activity : "+this.activity);
		this.primengConfig.ripple = true;
		//this.formBuild();

		// if we were passed the whole activity object
		/*if (this.activity) {
			this.activityId = this.activity.activityId;
			this.fixDates();
			this.form1.patchValue(this.activity);
		}*/
		this.form1.patchValue({
			highlightDesc: this.textHighlight,
		});
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.activityId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Cancelled', detail: 'Delete cancelled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			if(this.form1.value.activityProviderId == null && this.form1.value.activityProviderId == undefined && this.form1.value.activityProviderId == "undefined"){
				this.form1.value.activityProviderId = this.activityProviderId;
			}
			if(this.form1.value.activityProviderId == null && this.activityProviderId == null){
				this.activityProviderIdRequired = true;
				this.messageService.add({ severity: 'error', summary: 'Validation Error', detail: "Activity provider is required" });
				return;
			}
			if(this.form1.value.availableDays != undefined && this.form1.value.availableDays != null && this.form1.value.availableDays.length > 0){
				var count = 0;
				var availableDay = null;
				for (var index in this.form1.value.availableDays) {
					if(count == 0){
						availableDay = this.form1.value.availableDays[index].value;
						count = count + 1;
					}else{
						availableDay = availableDay + ", " +this.form1.value.availableDays[index].value;
						count = count + 1;
					}
				}
				this.form1.value.availableDays = availableDay;
			}

			if(this.form1.value.pickUpAvailable != undefined && this.form1.value.pickUpAvailable != null && this.form1.value.pickUpAvailable.length > 0){
				var count = 0;
				var pickUpAvailable = null;
				for (var index in this.form1.value.pickUpAvailable) {
					if(count == 0){
						pickUpAvailable = this.form1.value.pickUpAvailable[index].value;
						count = count + 1;
					}else{
						pickUpAvailable = pickUpAvailable + ", " +this.form1.value.pickUpAvailable[index].value;
						count = count + 1;
					}
				}
				this.form1.value.pickUpAvailable = pickUpAvailable;
			}

			if(this.form1.value.accessibleTransport != undefined && this.form1.value.accessibleTransport != null && this.form1.value.accessibleTransport.length > 0){
				var count = 0;
				var accessibleTransport = null;
				for (var index in this.form1.value.accessibleTransport) {
					if(count == 0){
						accessibleTransport = this.form1.value.accessibleTransport[index].value;
						count = count + 1;
					}else{
						accessibleTransport = accessibleTransport + ", " +this.form1.value.accessibleTransport[index].value;
						count = count + 1;
					}
				}
				this.form1.value.accessibleTransport = accessibleTransport;
			}

			if(this.form1.value.eatingTime != undefined && this.form1.value.eatingTime != null && this.form1.value.eatingTime.length > 0){
				var count = 0;
				var eatingTime = null;
				for (var index in this.form1.value.eatingTime) {
					if(count == 0){
						eatingTime = this.form1.value.eatingTime[index].value;
						count = count + 1;
					}else{
						eatingTime = eatingTime + ", " +this.form1.value.eatingTime[index].value;
						count = count + 1;
					}
				}
				this.form1.value.eatingTime = eatingTime;
			}

			if(this.form1.value.language != undefined && this.form1.value.language != null && this.form1.value.language.length > 0){
				var count = 0;
				var language = null;
				for (var index in this.form1.value.language) {
					if(count == 0){
						language = this.form1.value.language[index].value;
						count = count + 1;
					}else{
						language = language + ", " +this.form1.value.language[index].value;
						count = count + 1;
					}
				}
				this.form1.value.language = language;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.activityService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.activity = res.data.activity;
						this.doAdd.emit(this.activity);
						this.router.navigate(['activities']);
					},
					(err: any) => {
						console.log('activity-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('activity: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			if(this.form1.value.availableDays != undefined && this.form1.value.availableDays != null && this.form1.value.availableDays.length > 0){
				var count = 0;
				var availableDay = null;
				for (var index in this.form1.value.availableDays) {
					if(count == 0){
						availableDay = this.form1.value.availableDays[index].value;
						count = count + 1;
					}else{
						availableDay = availableDay + ", " +this.form1.value.availableDays[index].value;
						count = count + 1;
					}
				}
				this.form1.value.availableDays = availableDay;
			}

			if(this.form1.value.pickUpAvailable != undefined && this.form1.value.pickUpAvailable != null && this.form1.value.pickUpAvailable.length > 0){
				var count = 0;
				var pickUpAvailable = null;
				for (var index in this.form1.value.pickUpAvailable) {
					if(count == 0){
						pickUpAvailable = this.form1.value.pickUpAvailable[index].value;
						count = count + 1;
					}else{
						pickUpAvailable = pickUpAvailable + ", " +this.form1.value.pickUpAvailable[index].value;
						count = count + 1;
					}
				}
				this.form1.value.pickUpAvailable = pickUpAvailable;
			}

			if(this.form1.value.accessibleTransport != undefined && this.form1.value.accessibleTransport != null && this.form1.value.accessibleTransport.length > 0){
				var count = 0;
				var accessibleTransport = null;
				for (var index in this.form1.value.accessibleTransport) {
					if(count == 0){
						accessibleTransport = this.form1.value.accessibleTransport[index].value;
						count = count + 1;
					}else{
						accessibleTransport = accessibleTransport + ", " +this.form1.value.accessibleTransport[index].value;
						count = count + 1;
					}
				}
				this.form1.value.accessibleTransport = accessibleTransport;
			}

			if(this.form1.value.eatingTime != undefined && this.form1.value.eatingTime != null && this.form1.value.eatingTime.length > 0){
				var count = 0;
				var eatingTime = null;
				for (var index in this.form1.value.eatingTime) {
					if(count == 0){
						eatingTime = this.form1.value.eatingTime[index].value;
						count = count + 1;
					}else{
						eatingTime = eatingTime + ", " +this.form1.value.eatingTime[index].value;
						count = count + 1;
					}
				}
				this.form1.value.eatingTime = eatingTime;
			}

			if(this.form1.value.language != undefined && this.form1.value.language != null && this.form1.value.language.length > 0){
				var count = 0;
				var language = null;
				for (var index in this.form1.value.language) {
					if(count == 0){
						language = this.form1.value.language[index].value;
						count = count + 1;
					}else{
						language = language + ", " +this.form1.value.language[index].value;
						count = count + 1;
					}
				}
				this.form1.value.language = language;
			}
			this.activityService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.activity = res.data.activity;
						this.doUpdate.emit(this.activity);
						this.router.navigate(['activities']);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.activityService.delete(this.activity.activityId)
				.subscribe(
					(res: any) => {
						console.log('activity-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.activity);
					},
					(err: any) => {
						console.log('activity-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			activityId: [this.activityId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			opsNotes: [],
			status: [],
			activityType: [],
			invoiceType: [],
			overviewDesc: [],
			detailsDesc: [],
			duration: [],
			durationDesc: [],
			checkInDesc: [],
			parkingDesc: [],
			menuDesc: [],
			cancelPolicy: [],
			activityProviderId: [this.activityProviderId],
			adrType: [],
			adrStreetNumber: [],
			adrStreetName: [],
			adrUnit: [],
			adr2: [],
			adrCity: [],
			adrCounty: [],
			adrCountry: [],
			adrRegion: [],
			adrState: [],
			adrPostalCode: [],
			adrIsland: [],
			adrCrossStreet: [],
			adrLongitude: [],
			adrLatitude: [],
			locationCategory: [],
			highlightDesc: [],
			feeDesc: [],
			scheduleDesc: [],
			termsDesc: [],
			availableDays: [],
			pickUpAvailable: [],
			accessibleTransport: [],
			eatingTime: [],
			language: [],
			leadDescription: ['', Validators.required],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.activity.activityDate = moment(this.activity.activityDate).toDate();
	}
	
	fetchActivityProviders() {
		if (!this.activityProviders || this.activityProviders === undefined || this.activityProviders.length < 1) {
			try {
				this.activityProviderService.findAll()
					.subscribe(
						res => {
							console.log('findAllActivityProvidersSummary: ' + JSON.stringify(res));
							this.activityProviders = res.data.activityProviders;
							return this.activityProviders;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.activityProviders);
		}
	}
	
	selectProvider(){
		this.activityProviderIdRequired = false;
	}

	addIntoCheckedList(picture: any){
		if (this.forDeletePictures.includes(picture.pictureId)) {
			this.forDeletePictures.splice(this.forDeletePictures.indexOf(picture.pictureId), 1);
		}else{
			this.forDeletePictures.push(picture.pictureId);
		}
		console.log("forDeletePictures : "+this.forDeletePictures);
	}
	
	selectAllPictures(){
		this.forDeletePictures = [];
		for (var index in this.pictures) {
			this.pictures[index].checked = true;
			this.forDeletePictures.push(this.pictures[index].pictureId);
		}
		console.log("forDeletePictures after select all : "+this.forDeletePictures);
	}
	
	unSelectAllPictures(){
		this.forDeletePictures = [];
		for (var index in this.pictures) {
			this.pictures[index].checked = false;
		}
		console.log("forDeletePictures after deselect all : "+this.forDeletePictures);
	}

	/********** Delete Image from DB + S3 **********/
	onDelete(image) {
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + image.pictureId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				try {
					this.formLoading = true;
					this.pictureService.removePicture(image.pictureId)
						.subscribe(
							res => {
								console.log('formDelete SUCCESS: ' + JSON.stringify(res));
								this.pictures.splice(this.pictures.indexOf(image), 1);
								this.images = this.pictures;
								this.loadLazy(this.lazyLoadEvent);
								this.recordTotal = this.pictures.length;
								this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });

							},
							err => {
								console.log('formDelete FAIL: ' + JSON.stringify(err));
								this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Delete failed: ' + err.message, sticky: true });
							},
							() => { this.formLoading = false; });

				} catch (error) {
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'General error: ' + error, sticky: true });
				}
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Cancelled', detail: 'Delete cancelled.', life: 3000 });
			}
		});
	}

	/********** Delete Image from DB + S3 **********/
	deleteMultiplePictures() {
		try {
					this.formLoading = true;
					this.pictureService.removeMultiplePicture(this.forDeletePictures)
						.subscribe(
							res => {
								console.log('formDelete SUCCESS: ' + JSON.stringify(res));
								for (let i = 0; i < this.forDeletePictures.length-1; i++) {
								  this.pictures.splice(this.pictures.indexOf(this.forDeletePictures[i]), 1);
								}
								this.forDeletePictures = [];
								this.images = this.pictures;
								this.loadLazy(this.lazyLoadEvent);
								this.recordTotal = this.pictures.length;
								this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });

							},
							err => {
								console.log('formDelete FAIL: ' + JSON.stringify(err));
								this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Delete failed: ' + err.message, sticky: true });
							},
							() => { this.formLoading = false; });

				} catch (error) {
					console.log('Form Invalid: ' + JSON.stringify(error));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'General error: ' + error, sticky: true });
				}
	}


	/********** Load Images from DB **********/
	loadLazy(event: LazyLoadEvent) {
		try {
			this.formLoading = true;
			this.lazyLoadEvent = event;
			const pageNumber = Math.round(event.first / event.rows);

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			// If we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			let springQuery = new SpringQuery();
			springQuery.addEquals('size', '200');
			if (this.activityId) {
				springQuery.addEquals('activityVO.activityId', this.activityId.toString())
			}
			this.pictureService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters,
				springQuery).pipe(first()).subscribe(

					res => {
						console.log('Load SUCCESS: ' + JSON.stringify(res))
						this.pictures = res.data.pictures;
						if(this.pictures.length > 0){
							this.isPicture = false;
						}else{
							this.isPicture = true;
						}
						for (var index in this.pictures) {
							this.pictures[index].checked = false;
						}
						console.log("pppppppppppppppppppppppppppppppppppppppppppppppppppppppp : "+JSON.stringify(this.pictures));
						this.pictures.sort((t1, t2) => {
							if (t1.sortOrder > t2.sortOrder) {
								return 1;
							}

							if (t1.sortOrder < t2.sortOrder) {
								return -1;
							}

							return 0;
						});
						this.images = this.pictures;
						this.recordTotal = res.page.recordTotal;
						this.formLoading = false;
					},
					err => {
						console.log('Load FAIL: ' + JSON.stringify(err));
						this.formLoading = false;
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message, sticky: true });
					},
					() => { this.formLoading = false; }
				);

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, sticky: true });
		}
	}

	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		// this.onOpenFormEdit(event.data);
	}

	myUploader(event: any) {
		this.pictureIndex = 0;
		this.uploadedFiles = event.files;
		this.uploadPicture();
	}
	
	uploadPicture() {
		this.formLoading = true;
		console.log('File name: ' + JSON.stringify(this.uploadedFiles[this.pictureIndex].name));
		try {
			this.pictureService.uploadFileActivity(this.uploadedFiles[this.pictureIndex], this.activityId)
				.subscribe(
					res => {
						this.pictureIndex = this.pictureIndex + 1;
						if (this.uploadedFiles.length != this.pictureIndex) {
							this.uploadPicture();
						} else {
							this.isPicture = false;
							this.loadLazy(this.lazyLoadEvent);
							this.messageService.add({ severity: 'success', summary: 'Success', detail: "Upload All Image Successfully" });
							this.formLoading = false;
						}
						console.log('Update picture successfully: ' + JSON.stringify(res));
					},
					err => {
						this.pictureIndex = this.pictureIndex + 1;
						if (this.uploadedFiles.length != this.pictureIndex) {
							this.uploadPicture();
						} else {
							this.loadLazy(this.lazyLoadEvent);
							this.formLoading = false;
						}
						console.log('Update picture sort order FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { 
						if (this.uploadedFiles.length == this.pictureIndex) {
							this.loadLazy(this.lazyLoadEvent);
							this.formLoading = false;
						}
					});
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
		}
	}

}
